import { schema } from 'normalizr';

export const homepageSchema = new schema.Entity('homePages', {}, { idAttribute: 'HomePageId' });

export const homepageListSchema = [homepageSchema];
